// cspell:disable
export const languages = [
  {
    name: "English",
    englishName: "English",
    locale: "en-us",
  },
  {
    name: "Deutsch",
    englishName: "German",
    locale: "de-de",
  },
  {
    name: "日本語",
    englishName: "Japanese",
    locale: "ja-jp",
  },
  {
    name: "Dutch",
    englishName: "Dutch",
    locale: "nl",
  },
  {
    name: "Português",
    englishName: "Portuguese",
    locale: "pt-br",
  },
  {
    name: "Español",
    englishName: "Spanish",
    locale: "es",
  },
  {
    name: "Català",
    englishName: "Catalan",
    locale: "ca",
  },
  {
    name: "Français",
    englishName: "French",
    locale: "fr",
  },
  {
    name: "Bahasa Indonesia",
    englishName: "Indonesian",
    locale: "id-id",
  },
  {
    name: "Italiano",
    englishName: "Italian",
    locale: "it-it",
  },
  {
    name: "Polski",
    englishName: "Polish",
    locale: "pl",
  },
  {
    name: "Svenska",
    englishName: "Swedish",
    locale: "sv",
  },
  {
    name: "Suomi",
    englishName: "Finnish",
    locale: "fi",
  },
  {
    name: "Русский",
    englishName: "Russian",
    locale: "ru-ru",
  },
  {
    name: "tiếng Việt",
    englishName: "Vietnamese",
    locale: "vi-vn",
  },
  {
    name: "简体中文",
    englishName: "Simplified Chinese",
    locale: "zh-cn",
  },
  {
    name: "正體中文",
    englishName: "Traditional Chinese",
    locale: "zh-tw",
  },
  {
    name: "한국인",
    englishName: "Korean",
    locale: "ko-kr",
  },
  {
    name: "ไทย",
    englishName: "Thai",
    locale: "th-th",
  },
];

export const languageToNewFormat = (language: string) => {
  if (language === "es") {
    return "es_ES";
  }

  return language?.replace(/(-.*$)/, (match) =>
    match.replace("-", "_").toUpperCase(),
  );
};

export const languageToOldFormat = (language: string) => {
  if (language === "es_ES") {
    return "es";
  }

  return language?.replace(/(_.*$)/, (match) =>
    match.replace("_", "-").toLowerCase(),
  );
};

/**
 * Maps an app locale (e.g. "en-us", "en_US", "zh-tw") to the ISO 639-1
 * language code expected by Stream Chat's auto-translation API.
 */
export const localeToStreamLanguage = (locale: string): string => {
  const lower = locale.toLowerCase().replace("_", "-");

  if (lower === "zh-tw") return "zh-TW";

  return lower.split("-")[0] ?? "en";
};

/**
 * Swaps the locale segment of a pathname for `newLocale`. Returns `undefined`
 * when `pathname` has no locale segment (e.g. `trackingRoute`/`referralRoute`,
 * which sit outside the `/v2/$locale` wrapper) — callers should no-op in that
 * case rather than mangling an unrelated path segment.
 */
export const replaceLocaleInPath = (
  pathname: string,
  newLocale: string,
  supportedLocales: Set<string>,
): string | undefined => {
  const pathSegments = pathname.split("/");
  const localeIndex = pathSegments.findIndex((segment) =>
    supportedLocales.has(segment.toLowerCase()),
  );

  if (localeIndex === -1) return undefined;

  pathSegments[localeIndex] = newLocale;
  return pathSegments.join("/");
};
